// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"burgeringredients__BreadBottom__1wFNk","BreadTop":"burgeringredients__BreadTop__23tB0","Seeds1":"burgeringredients__Seeds1__2G4oP","Seeds2":"burgeringredients__Seeds2__262EN","Meat":"burgeringredients__Meat__25lvR","Cheese":"burgeringredients__Cheese__2077y","Salad":"burgeringredients__Salad__1-9_v","Bacon":"burgeringredients__Bacon__NIPHB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredients/burgeringredients.css
// module id = 138
// module chunks = 3